import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import {
  createEmail,
  updateEmail,
  getEmail,
  deleteEmail,
  UpdatePrimaryEmail,
} from "../../../Utility/Api";
import { Deletemodel } from "../../Common/Functions";
import { WarehouseContext } from "../../../Utility/UserContext";

const Emaillog = () => {
  const [emailList, setEmailList] = useState([]);
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [editData, setEditData] = useState({
    id: null,
    created_by: "",
    email: "",
    status: 0,
  });
  const [loading, setLoading] = useState(false);

  // Load initial data

  const handleAddEmail = () => {
    setEditData({ id: null, created_by: "", email: "", status: 0 });
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditData({
      id: item.id,
      created_by: item.created_by,
      email: item.email,
    });
    setShowModal(true);
  };

  const handleDeleteModal = (ID) => {
    showDeleteModal(true);
    setDeleteId(ID);
  };

  const fetchEmaillist = async () => {
    try {
      const response = await getEmail();
      if (response.data && response.data.data) {
        setEmailList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching email data:", error);
      toast.error("Error fetching email");
    }
  };

  useState(() => {
    fetchEmaillist();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!editData.created_by || !editData.email) {
      toast.error("Please fill all fields");
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(editData.email)) {
      toast.error("Please enter a valid email");
      return;
    }

    if (editData.id) {
      const res = await updateEmail(editData?.id, editData);
      fetchEmaillist();
      toast.success("Email updated successfully");
    } else {
      const res = await createEmail(editData);
      fetchEmaillist();
      toast.success("Email added successfully");
    }

    setShowModal(false);
  };

  const handleDelete = async () => {
    try {
      await deleteEmail(deleteId);
      fetchEmaillist();
      toast.success("Email Deleted successfully");
      showDeleteModal(false);
    } catch (error) {
      console.error("Error Deleting:", error);
      // toast.error('Error deleting unit');
    }
  };

  const UpdatePrimaryEmailfunction = async (ID) => {
    showLoader();
    try {
      await UpdatePrimaryEmail(ID);
      await fetchEmaillist();
      hideLoader();
      toast.success("Email has been successfully updated as Primary");
    } catch (error) {
      console.error("ErrorPrimary :", error);
      // toast.error('Error deleting unit');
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Email</h6>
          <button
            type="button"
            onClick={handleAddEmail}
            className="btn btn-primary mb-0"
            style={{ fontFamily: "poppins" }}
          >
            Add Email
          </button>
        </div>
        <hr className="mt-1" />

        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="table table-striped table-sm table-bordered align-baseline"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {emailList.map((item, index) => (
                    <tr key={item.id}>
                      <td
                        style={{
                          backgroundColor: item.status == 1 ? "#90ee9080" : "",
                        }}
                        className={item.status == 0 ? "bg-green-100" : ""}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          backgroundColor: item.status == 1 ? "#90ee9080" : "",
                        }}
                      >
                        {item.created_by}
                      </td>
                      <td
                        style={{
                          backgroundColor: item.status == 1 ? "#90ee9080" : "",
                        }}
                      >
                        {item.email}
                      </td>
                      <td
                        style={{
                          backgroundColor: item.status == 1 ? "#90ee9080" : "",
                        }}
                      >
                        <img
                          src="/assets/images/icons/edit.png"
                          onClick={() => handleEdit(item)}
                          height="20px"
                          alt="Edit"
                          style={{ cursor: "pointer" }}
                        />
                        <img
                          src="/assets/images/icons/delete.png"
                          className="mx-1"
                          onClick={() => handleDeleteModal(item.id)}
                          height="20px"
                          alt="Delete"
                          style={{ cursor: "pointer" }}
                        />
                        {item.status == 0 && (
                          <img
                            src="/assets/images/icons/primary.png"
                            className="mx-1"
                            onClick={() => UpdatePrimaryEmailfunction(item.id)}
                            height="20px"
                            alt="Primary"
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Email Add/Edit Modal */}
      {showModal && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editData.id ? "Edit " : "Add "}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.created_by}
                      onChange={(e) =>
                        setEditData({ ...editData, created_by: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={editData.email}
                      onChange={(e) =>
                        setEditData({ ...editData, email: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-success">
                      {editData.id ? "Update" : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModal && (
        <Deletemodel
          setShowModal={showDeleteModal}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
};
export default Emaillog;

// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify';
// import { createdata, updatedata, getdata, deletedata } from '../../../Utility/Api';
// import { Deletemodel } from '../../Common/Functions';

// const Emaillog = () => {
//   const [emailList, setEmailList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [deleteModal, showDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [editData, setEditData] = useState({ id: null, name: '', email: '' });

//   useEffect(() => {
//     logdata();
//   }, []);

//   const logdata = async () => {
//     try {
//       const res = await getdata('emaillog');
//       setEmailList(res.data || []);
//     } catch (err) {
//       console.error(err);
//       toast.error('Failed to load email logs');
//     }
//   };

//   const handleAddEmail = () => {
//     setEditData({ id: null, name: '', email: '' });
//     setShowModal(true);
//   };

//   const handleEdit = (item) => {
//     setEditData({ id: item.id, name: item.name, email: item.email });
//     setShowModal(true);
//   };

//   const handleDeleteModal = (ID) => {
//     showDeleteModal(true);
//     setDeleteId(ID);
//   };

//   const handleDelete = async () => {
//     try {
//       await deletedata('emaillog', deleteId);
//       toast.success('Entry deleted successfully');
//       showDeleteModal(false);
//       logdata();
//     } catch (error) {
//       console.error('Error deleting entry:', error);
//       toast.error('Error deleting entry');
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!editData.name || !editData.email) {
//       toast.error('Please fill all fields');
//       return;
//     }

//     if (!/^\S+@\S+\.\S+$/.test(editData.email)) {
//       toast.error('Please enter a valid email');
//       return;
//     }

//     try {
//       if (editData.id) {
//         await updatedata('emaillog', editData);
//         toast.success('Entry updated successfully');
//       } else {
//         await createdata('emaillog', editData);
//         toast.success('New entry added successfully');
//       }
//       setShowModal(false);
//       logdata();
//     } catch (err) {
//       console.error(err);
//       toast.error('Something went wrong');
//     }
//   };

//   return (
//     <div className="page-wrappers">
//       <div className="page-content">
//         <div className="mb-0 d-flex justify-content-between align-items-center">
//           <h6 className="mb-0 text-uppercase">Email Log</h6>
//           <button
//             type="button"
//             onClick={handleAddEmail}
//             className="btn btn-primary mb-0"
//             style={{ fontFamily: 'poppins' }}
//           >
//             Add Data
//           </button>
//         </div>
//         <hr className="mt-1" />

//         <div className="card">
//           <div className="card-body">
//             <div className="table-responsive">
//               <table
//                 className="table table-striped table-sm table-bordered align-baseline"
//                 style={{ width: '100%', fontFamily: 'poppins' }}
//               >
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>Name</th>
//                     <th>Email</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {emailList.map((item, index) => (
//                     <tr key={item.id}>
//                       <td>{index + 1}</td>
//                       <td>{item.name}</td>
//                       <td>{item.email}</td>
//                       <td>
//                         <img
//                           src="/assets/images/icons/edit.png"
//                           onClick={() => handleEdit(item)}
//                           height={'20px'}
//                           alt="Edit"
//                           style={{ cursor: 'pointer' }}
//                         />
//                         <img
//                           src="/assets/images/icons/delete.png"
//                           className="mx-1"
//                           onClick={() => handleDeleteModal(item.id)}
//                           height={'20px'}
//                           alt="Delete"
//                           style={{ cursor: 'pointer' }}
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Email Add/Edit Modal */}
//       {showModal && (
//         <div
//           className="modal"
//           style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
//         >
//           <div className="modal-dialog">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   {editData.id ? 'Edit Data' : 'Add Data'}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="mb-3">
//                     <label className="form-label">Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={editData.name}
//                       onChange={(e) =>
//                         setEditData({ ...editData, name: e.target.value })
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label className="form-label">Email</label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       value={editData.email}
//                       onChange={(e) =>
//                         setEditData({ ...editData, email: e.target.value })
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="modal-footer">
//                     <button
//                       type="button"
//                       className="btn btn-secondary"
//                       onClick={() => setShowModal(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       {editData.id ? 'Update' : 'Save'}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {deleteModal && (
//         <Deletemodel
//           setShowModal={showDeleteModal}
//           handleDelete={handleDelete}
//         />
//       )}
//     </div>
//   );
// };

// export default Emaillog;
